import React, { forwardRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import ReactPatternLock from 'react-pattern-lock';
import TFAVerify from './tfaVerify';
import { useSignin } from './api/apiAuthentication';
import { RotateCcw } from 'lucide-react';
import { CircularProgress } from '@mui/material';
import user from '../assets/images/icons/user.svg'
import lock from '../assets/images/icons/lock.svg'
import eyeslash from '../assets/images/icons/eye-slash.svg'
import eye from '../assets/images/icons/eye.svg'
import logocolor from '../assets/images/logocolor.png'
const EMAILID_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

const schema = yup.object().shape({
    email: yup.string()
        .required('Enter email')
        .matches(EMAILID_REGEX, 'Enter a valid email'),
    password: yup
        .string()
        .required('Enter a password')
        .min(8, 'Password should be atleast 8 characters.')
        .max(16, 'Password should be atmost 16 characters.')
        .required('Password is Required'),
    pattern: yup.array()
        .min(1, 'Draw a pattern')
        .required()
        .typeError('Connect atleast 4 dots')
        .min(4, 'Connect atleast 4 dots'),
})

// eslint-disable-next-line react/display-name
const PatternLock = forwardRef((props, ref) => (
    <ReactPatternLock {...props} ref={ref} />
))

const Login = () => {

    const signinMutation = useSignin();

    const [tfaStatus, setTfaStatus] = useState(false);

    const isHtmlClassActive = sessionStorage.getItem('theme-dark') === 'true'

    isHtmlClassActive ? document.documentElement.classList.add('theme-dark') : document.documentElement.classList.remove('theme-dark')
    const { control, handleSubmit, formState: { errors }, reset, getValues, setValue } = useForm({
        mode: 'onChange',
        resolver: yupResolver(schema),
        defaultValues: {
            email: '',
            password: '',
            pattern: []
        }
    });

    const [inputType, setInputType] = useState(true);
    const toggleInputType = () => {
        setInputType(!inputType);
    };

    const clearPattern = () => {
        setValue('pattern', [])
    }

    const onSubmit = async (data) => {
        const pattern = data.pattern.map((e) => e + 1).join('')
        const obj = {
            email: data.email,
            password: data.password,
            pattern: pattern
        }

        const res = await signinMutation.mutateAsync(obj)

        if (res?.data && res?.data?.tfaStatus === false) {
            setTimeout(() => {
                window.location.href = "/dashboard"
            }, 1000);
            sessionStorage.setItem('permission', JSON.stringify(res.data?.admin?.permission))
            sessionStorage.setItem('role', res?.data?.role)
            reset();
            sessionStorage.setItem("apayroucarayxczijiuhxvkdsp", res?.data?.token)

        } else if (res?.data?.tfaStatus) {
            setTfaStatus(true)
        }
    }



    return (

        <div className='LoginRegBg '>
            <div className='crPg-bg-color crPg-bg-image'>
                <section>
                    <div className="container ">
                        <div className="row align-items-center justify-content-center min-vh-100 py-4">
                            <div className="col">
                                <div className="crPgBr mw-856">
                                    <div className="crPg">
                                        <div className="row g-0">
                                            <div className="col-md-6">
                                                <div className="crPgWlc crPgWlc-bg-color">
                                                    <div className="crPgLogo">
                                                        <img src={logocolor} className='img-fluid' alt="Logo" width="250px" />

                                                    </div>
                                                    <div className="crPgWclTx crPgWcl-tx-color">
                                                        <h1>Welcome back</h1>
                                                        <p>Please enter your details to sign in</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                {tfaStatus ?
                                                    <TFAVerify email={getValues("email")} password={getValues('password')} pattern={getValues('pattern')} />
                                                    :
                                                    <div className="crPgFrm crPgFrmIps">
                                                        <div className="crPgWcl-tx-color mb-3">
                                                            <h3>Sign-in to continue.</h3>
                                                        </div>
                                                        <form onSubmit={handleSubmit(onSubmit)} noValidate>
                                                            <div className="input-group mb-3">
                                                                <span className="input-group-icon">
                                                                    <img src={user} className='img-fluid' alt="User" />
                                                                </span>
                                                                <Controller name='email' control={control} render={({ field }) => (
                                                                    <input
                                                                        {...field}
                                                                        type="text"
                                                                        autoFocus='on'
                                                                        disabled={signinMutation.isLoading}
                                                                        className="form-control"
                                                                        placeholder='Enter email address'
                                                                        autoComplete='off'
                                                                    />
                                                                )} />

                                                            </div>
                                                            {errors.email && <p className="errMsg">* {errors.email.message}</p>}
                                                            <div className="input-group mb-3">
                                                                <span className="input-group-icon">
                                                                    <img src={lock} className='img-fluid' alt="lock" />
                                                                </span>
                                                                <Controller name='password' control={control} render={({ field }) => (
                                                                    <input
                                                                        {...field}
                                                                        type={inputType ? "password" : "text"}
                                                                        id="inputpassword"
                                                                        disabled={signinMutation.isLoading}
                                                                        className="form-control"
                                                                        placeholder='Enter your password'
                                                                        autoComplete='off'
                                                                    />
                                                                )} />

                                                                <button type="button" onClick={toggleInputType} className={`btn p-0 input-group-icon border-0 shwPwd ${inputType ? "" : "show-eye"}`.trim()} >
                                                                    <img src={eyeslash} className='img-fluid eye-hide' alt="eye-slash" />
                                                                    <img src={eye} className='img-fluid eye-show' alt="eye" />
                                                                </button>
                                                            </div>
                                                            {errors.password && <p className="errMsg">* {errors.password.message}</p>}
                                                            <div className='d-flex justify-content-end'>
                                                                <button type="button" className="btn btn-outline-link p-0" onClick={clearPattern}>
                                                                    <RotateCcw size={20} />
                                                                </button>
                                                            </div>
                                                            <div className="pdLock pt-2 pb-3 text-center">
                                                                <Controller
                                                                    name='pattern'
                                                                    control={control}
                                                                    render={({ ref, field }) => (
                                                                        <PatternLock
                                                                            {...field}
                                                                            ref={ref}
                                                                            width={300}
                                                                            disabled={signinMutation.isLoading}
                                                                            size={3}
                                                                            path={field.value}
                                                                            style={{
                                                                                margin: "0 auto"
                                                                            }}
                                                                            onFinish={() => { }}
                                                                        />
                                                                    )}
                                                                />
                                                            </div>
                                                            {errors.pattern && <p className="errMsg">* {errors.pattern.message}</p>}

                                                            <div className="row gy-2 py-1 justify-content-between fgtLks">
                                                                <div className="col-auto">
                                                                    <Link to="/forgot-password">
                                                                        Forgot Password?
                                                                    </Link>
                                                                </div>
                                                                <div className="col-auto">
                                                                    <Link to="/forgot-pattern">
                                                                        Forgot Pattern?
                                                                    </Link>
                                                                </div>
                                                            </div>
                                                            <div className="d-grid crPgbtn pt-3">
                                                                <button type="submit" className="btn btn-primary" disabled={signinMutation.isLoading}>
                                                                    {signinMutation.isLoading ? <CircularProgress size={20} style={{ color: "#000" }} /> : "Login"}
                                                                </button>
                                                            </div>
                                                        </form>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>

    )
}
export default Login;